import { Link } from "react-router-dom";

interface RelatedLink {
  label: string;
  description: string;
  href: string;
  icon: string;
}

interface RelatedContentProps {
  title?: string;
  subtitle?: string;
  description?: string;
  links: RelatedLink[];
}

export default function RelatedContent({
  title = "Related Content",
  subtitle = "Explore Further",
  description,
  links,
}: RelatedContentProps) {
  return (
    <section className="section-padding bg-background-100">
      <div className="container-page">
        <div className="mb-10 text-center">
          {subtitle && (
            <p className="text-sm font-semibold uppercase tracking-wider mb-3 text-accent-600">
              {subtitle}
            </p>
          )}
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight text-foreground-950">
            {title}
          </h2>
          {description && (
            <p className="mt-4 text-base md:text-lg max-w-3xl mx-auto leading-relaxed text-foreground-600">
              {description}
            </p>
          )}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {links.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className="card-base card-hover p-6 block group"
              aria-label={`${link.label} — learn more`}
            >
              <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center mb-4">
                <i className={`${link.icon} text-primary-600 text-lg`} aria-hidden="true"></i>
              </div>
              <h3 className="text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-700 transition-colors">
                {link.label}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {link.description}
              </p>
              <span className="mt-4 inline-flex items-center text-sm font-semibold text-primary-600 group-hover:text-primary-700 transition-colors">
                {link.label}
                <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform" aria-hidden="true"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}